// Tasks-mode reload query fields — shared so every NEW-lead refetch/counter path
// threads the SAME task_due_bucket and suppresses the contacts-mode contactedCount
// identically.
//
// Background (#32, #119): in tasks mode the BE owns the NEW-lead base via
// task_due_bucket. If a refetch omits it (or sends a contacts-mode contactedCount),
// the table collapses to the No-Tasks set. The pagination path
// (handlePaginationChange) already does this correctly; #119 folds the same handling
// into refreshTableWithCurrentFilters + refreshCountersOnly so a post-bulk-Complete
// refetch doesn't drop the active bucket.

/**
 * Returns the tasks-mode-sensitive reload fields.
 *
 * @param {boolean} liveTasksMode  resolved tasks-mode flag (ref-based at call site)
 * @param {object}  opts
 * @param {*}       opts.checklistStateValue  active checklist sub-tab value (or falsy)
 * @param {*}       opts.contactCount         contacts-mode contacted-count Redux slot
 * @param {*}       opts.taskDueBucket        the CURRENT bucket (taskDueBucketRef.current) — may be null
 * @returns {{ contactedCount: *, taskDueBucket: (string|undefined) }}
 */
export function taskModeReloadFields(liveTasksMode, { checklistStateValue, contactCount, taskDueBucket } = {}) {
    // Contacts-mode contacted-count value (only used when NOT in tasks mode).
    const contactsModeContactedCount = checklistStateValue ? 'All' : contactCount;
    return {
        // Never send a contacts-mode contactedCount in tasks mode (BE owns the base).
        contactedCount: liveTasksMode ? undefined : contactsModeContactedCount,
        // Preserve the EXACT current bucket — including null (deselected → view all).
        // NEVER fall back to '|| due_today': that re-imposes the filter on a bucket the
        // user deliberately cleared (memory: project-newlead-reload-filter-family).
        taskDueBucket: liveTasksMode ? (taskDueBucket || undefined) : undefined,
    };
}
